// ===================================================================
// KAIXO - CRMLeads
// ===================================================================
// Vista 'leads' del CRM: toolbar (buscar + filtro de estado + exportar
// CSV + nuevo lead) + lista de leads con status selector rápido.
// El editor de lead (nuevo/editar) sigue viviendo en CRMModal como
// modal, fuera de esta vista.
// ===================================================================

import React from 'react';
import { Icons } from '../Icons/Icons';
import ct from './i18n';

export default function CRMLeads({
    leads,
    totalLeads,
    loading,
    filters,
    onFiltersChange,    // (newFilters) => void (también dispara load)
    statusColors,
    onExportCsv,        // () => void
    onNewLead,          // () => void
    onEditLead,         // (lead) => void
    onStatusChange      // (leadId, newStatus) => void
}) {
    return (
        <>
            <div className="crm-toolbar">
                <input
                    className="crm-search"
                    placeholder={ct.search}
                    value={filters.search}
                    onChange={e => onFiltersChange({ ...filters, search: e.target.value, page: 1 })}
                />
                <select
                    className="crm-filter"
                    value={filters.status}
                    onChange={e => onFiltersChange({ ...filters, status: e.target.value, page: 1 })}
                >
                    <option value="">{ct.all}</option>
                    {Object.entries(ct.statuses || {}).map(([k, v]) => (
                        <option key={k} value={k}>{v}</option>
                    ))}
                </select>
                <button
                    className="crm-btn-secondary"
                    onClick={onExportCsv}
                    title={ct.exportCsvTitle || 'Descargar todos los contactos en un archivo Excel/CSV'}
                    style={{ padding: '6px 10px', whiteSpace: 'nowrap' }}
                >
                    📥 {ct.exportCsv || 'Exportar'}
                </button>
                <button
                    className="crm-btn-primary"
                    onClick={onNewLead}
                    title={ct.addLead || 'Nuevo contacto'}
                >
                    <Icons.Plus size={14} color="white" />
                </button>
            </div>

            <div className="crm-leads-count">
                {totalLeads} {ct.leads.toLowerCase()}
            </div>

            {loading ? (
                <p className="crm-center">{ct.loading}</p>
            ) : leads.length === 0 ? (
                <p className="crm-center crm-dim">{ct.noLeads}</p>
            ) : leads.map(l => (
                <div
                    key={l._id}
                    className="crm-lead-card"
                    onClick={() => onEditLead(l)}
                >
                    <div
                        className="crm-lead-status"
                        style={{ background: statusColors[l.status] || '#888' }}
                    />
                    <div className="crm-lead-info">
                        <div className="crm-lead-name">
                            {l.firstName} {l.lastName}
                        </div>
                        <div className="crm-lead-meta">
                            {l.phone && <span>{l.phone}</span>}
                            {l.email && <span>{l.email}</span>}
                        </div>
                        {l.phone && (
                            <div className="crm-lead-actions" onClick={e => e.stopPropagation()}>
                                <a href={`tel:${l.phone}`} className="crm-action-call" title="Llamar">
                                    <Icons.Microphone size={13} />
                                </a>
                            </div>
                        )}
                        <div className="crm-lead-badges">
                            <span className="crm-badge" style={{ background: statusColors[l.status] }}>
                                {ct.statuses?.[l.status] || l.status}
                            </span>
                            <span className="crm-badge-light">
                                {ct.sources?.[l.source] || l.source}
                            </span>
                            {l.budget > 0 && (
                                <span className="crm-badge-light">
                                    ${l.budget.toLocaleString()}
                                </span>
                            )}
                            {l.sourceDetail && (
                                <span
                                    className="crm-badge-light"
                                    title={l.sourceDetail}
                                >
                                    {l.sourceDetail.slice(0, 30)}
                                </span>
                            )}
                        </div>
                    </div>
                    <select
                        className="crm-status-select"
                        value={l.status}
                        onClick={e => e.stopPropagation()}
                        onChange={e => onStatusChange(l._id, e.target.value)}
                    >
                        {Object.entries(ct.statuses || {}).map(([k, v]) => (
                            <option key={k} value={k}>{v}</option>
                        ))}
                    </select>
                </div>
            ))}
        </>
    );
}
